import clsx from "clsx";
import React from "react";
import IconArrow from "../UI/Icon/IconArrow/IconArrow";
import styles from "./SwiperNavigationButton.module.scss";

interface SwiperNavigationButtonsProps {
	buttonIdentifier: string;
	buttonYPosition?: "middle";
	className?: string;
	prevButtonClassName?: string;
	nextButtonClassName?: string;
}

interface SwiperNavigationButtonProps extends SwiperNavigationButtonsProps {
	movement: "previous" | "next";
}

const SwiperNavigationButton: React.FC<SwiperNavigationButtonProps> = ({
	movement,
	buttonIdentifier,
	buttonYPosition,
	className,
}) => {
	return (
		<button
			type='button'
			aria-label={`button-${movement}`}
			data-button-ref={`${buttonIdentifier}-button-${movement}`}
			className={
				className ||
				clsx([
					styles.carouselArrowButtons,
					styles[`buttonPlacement--${movement}`],
					[buttonYPosition === "middle" ? styles.buttonYPosition : ""],
				])
			}
		>
			<IconArrow
				direction={movement}
				aria-labelledby={`directional chevron pointing down ${movement}`}
			/>
		</button>
	);
};

const SwiperNavigationButtons: React.FC<SwiperNavigationButtonsProps> = ({
	buttonIdentifier,
	prevButtonClassName,
	nextButtonClassName,
}) => {
	return (
		<>
			<SwiperNavigationButton
				movement='previous'
				buttonIdentifier={buttonIdentifier}
				buttonYPosition='middle'
				className={prevButtonClassName}
			/>

			<SwiperNavigationButton
				movement='next'
				buttonIdentifier={buttonIdentifier}
				buttonYPosition='middle'
				className={nextButtonClassName}
			/>
		</>
	);
};

export default SwiperNavigationButtons;
